const accounts = {
  namespaced: true,
  state: {
    userRoles: "",
    suppliers: [],
    customerList: [],
    eUserStatus: {
      Active: 100,
      Inactive: 200,
      DeleteRequest: 400,
    },
    accountDetails: null,
  },
  getters: {
    getSuppliersChanges(state) {
      return state.suppliers;
    },
    customerList(state) {
      return state.customerList;
    },
    accountDetails(state) {
      return state.accountDetails;
    },
  },
  mutations: {
    GET_RELATIONSHIPS: (state, payload) => {
      payload.response.data.relationships.forEach((relationship, index) => {
        if (payload.accountCategory == "buyer") {
          const supplier = {
            name: relationship.other.name,
            id: relationship.other.account_id,
            credit: relationship.credit,
            enabled: relationship.buyer.status === "ENABLED",
            enabled_first_time: relationship.other.enabled_first_time,
            seller_enabled:
              relationship.other.enabled_spot ||
              relationship.other.enabled_deliveredin ||
              relationship.other.enabled_bunkering,
            brands: relationship.other.brands,
          };

          state.suppliers.splice(index, index + 1, supplier);
        } else if (payload.accountCategory == "seller") {
          const customer = {
            name: relationship.buyer.name,
            id: relationship.buyer.account_id,
            credit: relationship.credit,
            premium: relationship.other.premium,
            enabled_spot: relationship.other.enabled_spot,
            enabled_bunkering: relationship.other.enabled_bunkering,
            enabled_deliveredin: relationship.other.enabled_deliveredin,
            restrictions: relationship.restrictions,
            relationshipId: relationship._id,
          };

          state.customerList.splice(index, index + 1, customer);
        }
      });
    },
    SORT_LIST_BY_NAME: (state, accountCategory) => {
      if (accountCategory == "buyer") {
        state.suppliers = state.suppliers.sort((a, b) => {
          const stringA = a.name.toLowerCase();
          const stringB = b.name.toLowerCase();

          if (stringA < stringB) {
            return -1;
          }
          if (stringA > stringB) {
            return 1;
          }
          return 0;
        });
      } else if (accountCategory == "seller") {
        state.customerList = state.customerList.sort((a, b) => {
          const stringA = a.name.toLowerCase();
          const stringB = b.name.toLowerCase();

          if (stringA < stringB) {
            return -1;
          }
          if (stringA > stringB) {
            return 1;
          }
          return 0;
        });
      }
    },
    SET_USER_ROLES: (state, payload) => {
      state.userRoles = Object.keys(payload)
        .filter((k) => ["type_id", "roles"].includes(k)) // Only append the type id and roles of this user
        .reduce((obj, key) => {
          obj[key] = payload[key];
          return obj;
        }, {});
    },
    SET_ACCOUNT_DETAILS: (state, payload) => {
      state.accountDetails = payload;
    },
  },
  actions: {
    getRelationships: async function ({ commit, dispatch, rootState }) {
      try {
        const response = await rootState.axios.get("/api/getRelationships");
        const payload = {
          accountCategory: rootState.login.userLoggedIn.category,
          response,
        };
        commit("GET_RELATIONSHIPS", payload);
        dispatch("sortListByName", payload.accountCategory);
      } catch (error) {
        console.log("error ", error);
      }
    },
    sortListByName: ({ commit }, payload) => {
      commit("SORT_LIST_BY_NAME", payload);
    },
    getUserRoles: async function ({ commit, rootState }) {
      try {
        const userRes = await rootState.axios.get("/api/getUserDetails", {
          params: {
            userId: rootState.login.userLoggedIn.userId,
          },
        });

        await commit("SET_USER_ROLES", userRes.data.user);
      } catch (er) {
        return; // TO-DO: Decide how to handle errors
      }
    },
    getAccountDetails: ({ commit, rootState }) => {
      rootState.axios
        .get("/api/getAccountDetails")
        .then((res) => {
          commit("SET_ACCOUNT_DETAILS", res.data);
        })
        .catch((error) => console.log(`Error fetching account details`, error));
    },
  },
};

export default accounts;
